<template>
  <section id="login" class="section">
    <div class="container">
      <div class="columns is-mobile is-centered">
        <div class="column is-two-fifths">
          <b-field label="Login" label-position="inside">
            <b-input
              custom-class="has-background-white"
              v-model="login"
            ></b-input>
          </b-field>
          <b-field label="Password" :message="[]" label-position="inside">
            <b-input
              custom-class="has-background-white"
              type="password"
              v-model="password"
            ></b-input>
          </b-field>
          <div class="has-text-centered">
            <b-button
              size="is-medium"
              type="is-caxton-yellow"
              rounded
              icon-left="arrow-right"
              @click="submit"
            >
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      login: "",
      password: ""
    };
  },
  methods: {
    wrongUserPassword() {
      this.$buefy.toast.open({
        duration: 3000,
        message: "Invalid user or password",
        position: "is-bottom",
        type: "is-danger"
      });
    },
    submit() {
      this.$auth
        .login({
          data: {
            client_id: process.env.VUE_APP_CI,
            client_secret: process.env.VUE_APP_CS,
            username: this.login,
            password: this.password,
            grant_type: "password"
          },
          redirect: { name: "Rutas" }
        })
        .then(() => {
          this.$store.commit("SET_ISLOGGED", true);
          this.$store.dispatch("GET_INFO");
        })
        .catch(e => {
          console.log("Error !!!");
          console.log(e);
          this.wrongUserPassword();
        });
    }
  },
  mounted() {
    //console.log(this.$auth.ready());
    //console.log(this.$store.getters.maininfo);
    if (this.$store.getters.maininfo == null) {
      //this.$store.dispatch("GET_INFO");
    }
  }
};
</script>

<style scoped></style>
